import {
  appVersion,
  appTimestamp,
  commitId,
  commitUrl,
  pullRequestId,
  pullRequestUrl,
  jiraTicketId,
  jiraTicketUrl,
  numberedEnv,
  isNumberedEnv,
  sentryDsn,
  amplitudeAPIKey,
  muiProKey,
} from "@src/runtime-config-base";
import { RuntimeConfig } from "@src/runtime-config-types";

export const runtimeConfig: RuntimeConfig = {
  environment: "staging",
  appRegion: "eu",
  appEnv: "eu-staging",
  displayAppEnv: "Staging EU",
  urls: {
    apiUrl: "https://core.api.staging.holobuilder.eu",
    baseUrl: "https://admin.staging.holobuilder.eu",
    dashboardUrl: "https://sphere.staging.holobuilder.eu",
    webEditorUrl: "https://app.staging.holobuilder.eu/app",
    entryPageUrl: "https://entry.staging.holobuilder.eu",
    adminPanelApi: "https://admin.staging.holobuilder.eu/api",
    cookieManagerUrl:
      "https://cookies.staging.holobuilder.eu/cookie-manager/manager/latest",
  },
  features: {
    muiProKey,
    amplitudeAPIKey,
  },
  keys: {
    sentryDsn,
  },
  appVersion,
  appTimestamp,
  commitId,
  commitUrl,
  pullRequestId,
  pullRequestUrl,
  jiraTicketId,
  jiraTicketUrl,
  mailSupportAddress: "support-eu+staging@holobuilder.com",
  isNumberedEnv,
  numberedEnv,
};
